import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { printStructuredData } from '@sparta.global.helpers/structured-data-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"structuredData") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":6,"column":11}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <script type=\"application/ld+json\">\r\n    "
    + container.escapeExpression((lookupProperty(helpers,"printStructuredData")||(depth0 && lookupProperty(depth0,"printStructuredData"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"printStructuredData","hash":{},"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":4,"column":32}}}))
    + "\r\n    </script>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"structuredData") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":2},"end":{"line":13,"column":11}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"structuredData") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":7,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"seoData") : depth0),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":0},"end":{"line":14,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/semantic-markup-module",
  "version": "1.0.5",
  "id": "semanticMarkupModule",
  "containerID": "globalSemanticMarkupModule",
  "moduleName": "global-semantic-markup-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "semantic-markup-module",
  "data": {
    "options": {},
    "init": "GlobalSemanticMarkupModule"
  },
  "moduleParams": [{
    "name": "pageSelector",
    "type": "string",
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        printStructuredData
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    printStructuredData
  },
  "dependencies": {
    "@sparta.global.helpers/structured-data-helper": "^1.0.4",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.16",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.5.1"
  },
  "stores": []
};

class SemanticMarkupModule extends Module {
  constructor(options) {
    super({
      ...options,
      config: _moduleConfig
    });
  }
  init() {
    // Do nothing.
  }
}
registerModuleClass({
  moduleClass: SemanticMarkupModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { SemanticMarkupModule as default, moduleConfig };
